export const FAQ_BLOCK_s1 = {
  "blockType": "FAQ",
  "blockDesign": "FAQDesign1",
  "editFormName": "FAQ_FORM_1",
  "styleProps": {
    "background-color": "#0f0f0f",
    "background-image": "url('')",
    "padding": "120px 20px 120px 20px"
  },
  "sectionConfigs": {
    "headerTextStyleProps": {
      "font-size": "1.125rem",
      "line-height": "1.75rem",
      "font-weight": "500",
      "padding": "14px 30px 14px 30px",
      "color": "#ffffff"
    },
    "bodyTextStyleProps": {
      "padding": "14px 30px 14px 30px",
      "color": ""
    },
    "sectionStyleProps": {
      "backgroundColor": "#f8f8f8",
      "padding": "10px",
      "border-width": "2px",
      "border-radius": "1.5rem",
      "border-color": "#292929",
      "margin": "0px 0px 8px 0px",
      "background-color": "#161616"
    }
  },
  "headings": [
    {
      "text": "FAQ",
      "styleProps": {
        "font-weight": "500",
        "text-align": "center",
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "padding": "4px 20px 4px 20px",
        "margin": "0px 20px 20px 20px",
        "color": "#33C6A2",
        "background-color": "#33C6A211",
        "border-radius": "9999px",
        "border-color": "#424242",
        "border-width": "1px"
      },
      "alignStyleProps": {
        "text-align": "center"
      }
    },
    {
      "text": "Some of the thing you may want to know",
      "styleProps": {
        "text-align": "center",
        "font-size": "3rem",
        "line-height": "1",
        "font-family": "'Lato', sans-serif",
        "font-weight": "500",
        "padding": "0px 20px 20px 20px",
        "margin": "0px 20px 20px 20px",
        "font-family-cust": "",
        "color": "#ffffff",
        "font-family-bk": "'Lato', sans-serif"
      }
    },
    {
      "text": "Get answers to common questions about our software development services and solutions. From project inquiries to technical details, we've got you covered.",
      "styleProps": {
        "text-align": "center",
        "font-size": "1.125rem",
        "line-height": "1.75rem",
        "color": "#cccccc",
        "padding": "0px 60px 80px 60px"
      },
      "stylePropsTab": {
        "padding": "0px 10px 80px 10px"
      }
    }
  ],
  "list": [
    {
      "headerText": "What subscription tiers can I subscribe to with flezr?",
      "bodyText": "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with"
    },
    {
      "headerText": "How much does a subscription to faq cost, and for how long can I subscribe?",
      "bodyText": "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with"
    },
    {
      "headerText": "Can we use the code/art/assets in Flezr Technologies' example projects?",
      "bodyText": "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with"
    }
  ],
  "metaDataId": 1746182470209,
  "afterIndex": 0,
  "blockId": 1746182470209,
  "fonts": {
    "headings": [
      null,
      ""
    ]
  },
  "containerStyleProps": {
    "padding": "0px 20px 0px 20px",
    "max-width": "800px"
  },
  "containerStylePropsTab": {
    "padding": "0px 20px 0px 20px"
  }
}